<template>
  <v-layout column>
    <section :class="$vuetify.breakpoint.name === 'xl' ? 'container' : ''">
      <v-container>
        <v-row
          justify="center"
          align="center"
          style="min-height: 77.6vh;">
          <v-col
            cols="12"
            md="6">
            <v-card
              flat
              class="border-radius pa-12">
              <v-row
                justify="center"
                align="center">
                <v-col
                  cols="12"
                  md="10">
                  <div class="mb-12">
                    <v-img
                      alt="not-allowed"
                      :src="require('@/assets/image/404.svg')"
                      max-height="200"
                      max-width="200"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class=" "
                          align="center"
                          justify="center">
                          <v-progress-circular
                            indeterminate
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>

                  <div class="text-center">
                    <div class="title text-first font-weight-bold my-4">
                      Akses Tidak Diizinkan
                    </div>

                    <div class="body-1 font-weight-light text-second line-text-second pb-8">
                      Anda tidak memiliki hak akses untuk halaman ini.
                    </div>

                    <v-btn
                      light
                      large
                      rounded
                      :color="set_color"
                      elevation="0"
                      class="body-1 font-weight-bold white--text text-capitalize"
                      to="/order">
                      <v-icon x-large>mdi-pan-left</v-icon>
                      Kembali ke Daftar Pemakaian
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </v-layout>
</template>

<script>
  export default {
    computed: {
      set_color () {
        return this.$store.state.color
      }
    }
  }
</script>

<style>
</style>

